import React from "react";
import { Dropdown } from "react-bootstrap";

const labels = {
  state: "State",
  filingState: "Filing State",
  filingCounty: "Filing County",
  filingDistrict: "Filing District",
};

// Keep the existing Formik change handlers and API values while presenting
// a consistent, keyboard-accessible menu on this form.
export default function CollectInfoSelect({ children, value, name, onChange, onBlur }) {
  const options = React.Children.toArray(children).filter(React.isValidElement);
  const selected = options.find((option) => String(option.props.value) === String(value || ""));
  const label = labels[name];
  return (
    <Dropdown className="collect-info-select">
      <Dropdown.Toggle
        id={`collect-${name}`}
        name={name}
        onBlur={onBlur}
        variant=""
        className={`form-control collect-info-select-trigger ${!value ? "is-placeholder" : ""}`}
        aria-label={label}
        disabled={options.length === 1 && options[0].props.children === "Loading..."}
      >
        <span>{selected?.props.children || `Select ${label.toLowerCase()}`}</span>
        <svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true">
          <path d="m5 7.5 5 5 5-5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Dropdown.Toggle>
      <Dropdown.Menu className="collect-info-select-menu" role="menu">
        {options.map((option) => (
          <Dropdown.Item
            key={option.props.value}
            role="menuitemradio"
            aria-checked={option === selected}
            active={option === selected}
            disabled={option.props.disabled}
            onClick={() => onChange?.({ target: { name, value: option.props.value } })}
          >
            <span>{option.props.children}</span>
            {option === selected && <span aria-hidden="true">✓</span>}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
